<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import upresult from './upresult/index.vue'
	import upfilesuccess from './upfilesuccess/index.vue'
	import showresult from './showresult/index.vue'
	import billdetails from './billdetails/index.vue'
	export default {
		name: 'nsreport',
		components: {
			upresult,
			showresult,
			billdetails,
			upfilesuccess,
		},
		data: function() {
			return {
				headlist: getdata().headlist,
				chooseindex: 0
			};
		},
		created() {
		},
		methods: {
			forchooseindex(e){
				this.chooseindex=e
			}
		}
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
